import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
  getAuthHeaders,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createStaff(staffData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff`;
    return httpPost(apiUrl, staffData);
  }

  modifyStaff(email, staffData) {
    delete staffData.pwd;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/${Crypto.encrypt(email, CryptoKey)}`;
    return httpPut(apiUrl, staffData);
  }

  async modifyStaffPwd(email, pwd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/${Crypto.encrypt(email, CryptoKey)}`;
    let res = await httpPut(apiUrl, { pwd });

    return res;
  }

  deleteStaff(email) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/${Crypto.encrypt(email, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  getStaffList(options = {}) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/getList`;
    return httpPost(apiUrl, options);
  }

  uploadStaffAvatar(staffID, avatar) {
    let photoData = new FormData();
    photoData.append("photo", avatar);

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/${Crypto.encrypt(staffID, CryptoKey)}/avatar`;
    return httpUploadFormData(apiUrl, photoData);
  }

  exportStaffList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/staff/export`;
    return httpGet(apiUrl, {
      responseType: 'arraybuffer',
      ...getAuthHeaders(),
    });
  }
}
